"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SvgError = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, props),
    React.createElement("path", { d: "M25.5 12a1.5 1.5 0 1 0-3 0v15a1.5 1.5 0 1 0 3 0zM24 31.5a2.25 2.25 0 1 0 0 4.501 2.25 2.25 0 0 0 0-4.5z" }),
    React.createElement("path", { fillRule: "evenodd", d: "M20.378 1.502a5.116 5.116 0 0 1 7.235-.008l.001.001L46.5 20.38c2 2 2 5.243 0 7.243L27.62 46.502a5.124 5.124 0 0 1-7.24 0L1.5 27.623c-2-2-2-5.243 0-7.243zm5.117 2.116a2.116 2.116 0 0 0-2.993.003L3.621 22.501a2.123 2.123 0 0 0 0 3L22.5 44.38a2.124 2.124 0 0 0 3 0l18.879-18.877a2.123 2.123 0 0 0 0-3z", clipRule: "evenodd" }))); };
exports.default = SvgError;
